const animatedResponses = new Set();

export default animatedResponses;